import React from "react";
import RatingItem from "./RatingItem";
import FrontSliderBlurb from "./FrontSliderBlurb";
import {contentURL} from "src/utilities/utilityFunctions";

const TwentyQuestionsSlide=()=>{
    return (
        <div className="ls-slide" data-ls="slidedelay:7000; transition2d: all;" id="twentyQuestionSlide">
            <img src={contentURL() + "/site/images/layerslider-gallery-tn/question-bg.png"}
                 className="ls-bg" alt="Slide background"/>

            <img className="ls-l" style={{top:"0px",left:"-160px",whiteSpace: "nowrap"}}
             data-ls="offsetyin:250;delayin:500;scalexin:23;scaleyin:23;offsetxout:0;parallaxlevel:2;easingin:easeInOutQuad;"
             src={contentURL() + "/site/images/layerslider-gallery/question-marks.png"} alt=""/>

            <img className="ls-l" style={{top:"-27px",left:"-141px",whiteSpace: "nowrap"}}
                 data-ls="offsetxin:2;offsetyin:-500;delayin:2900;offsetxout:0;parallaxlevel:-1;easingin:easeOutElastic;"
                 src={contentURL() + "/site/images/layerslider-gallery/learn-things.png"} alt="" />

            <img className="ls-l" style={{top:"450px",left:"-55px",whiteSpace: "nowrap"}}
                 data-ls="offsetxin:2;offsetyin:2000;delayin:5000;rotatexin:90;rotateyin:90;offsetxout:0;parallaxlevel:-1;easingin:easeOutBack;"
                 src={contentURL() + "/site/images/layerslider-gallery/play20q.png"} alt=""/>

            <div className="ls-l"
                 style={{top:"105px",left:"1350px"}}
                 data-ls="offsetxin:500;offsetyin:0;delayin:3500;easingin:easeOutQuart;offsetxout:500;offsetyout:0;parallaxlevel:1;"
                 key="blurb"
            >
                <FrontSliderBlurb delay="0" show="true"
                                  blurb={"Help them get past 'How was school?' and start getting to know each other."}/>
            </div>
            <RatingItem yeatitle={"...I LOVE this!!"}
                        mehtitle={"...I could go for it. Maybe."}
                        naytitle={"...I don't see the point."} bgcolor={"#EEEEEE"}
                        top={450} left={1050}
                        audience={"adult"}
                        feature={"20qstins"} label={"As an adult..."} key="sliderImage16"/>
            <RatingItem yeatitle={"LOVE this!!"}
                        mehtitle={"take It Or Leave It"}
                        naytitle={"not like this."} bgcolor={"#EEEEEE"}
                        top={459} left={1050} audience={"child"}
                        feature={"20qstins"}
                        label={"My child will..."}
                        key="sliderImage17"/>
        </div>

    )
};
export default TwentyQuestionsSlide;
